import React from 'react';
import { Routes, Route, NavLink, Link, useNavigate, BrowserRouter, Outlet, Navigate } from 'react-router-dom';
import DailyAttendance from './DailyAttendance';
import Home from './Home';
import nec_logo from './nec_logo.jpeg';
import LocationTrackingReport from './LocationTrackingReport';
import { useAuth } from './AuthContext';
import PortsList from './PortsList';
import PortCreate from './PortCreate';
import PortEdit from './PortEdit';
import DesignationList from './DesignationList';
import CreateDesignation from './CreateDesignation';
import EditDesignation from './EditDesignation';
import TerminalList from './TerminalList';
import CreateTerminal from './CreateTerminal';
import EditTerminal from './EditTerminal';
import ShiftList from './ShiftList';
import CreateShift from './CreateShift';
import EditShift from './EditShift';
import EmployeeList from './EmployeeList';
import CreateEmployee from './CreateEmployee';
import EditEmployee from './EditEmployee';
import EquipmentList from './EquipmentList';
import Login from './Login';
import CreateEquipmentActivity from './CreateEquipmentActivity';
import SiteTypePage from './SiteTypePage';
import PMSitePage from './PMSite';
import PMSitePlacePage from './PMSitePlace';
import PreventiveMaintenanceReport from './PreventiveMaintenanceReport';
import PMReportDetails from './PMReportDetails';
import PMStatus from './PMStatus';
import EngineerTaskDashboard from './EngineerTaskDashboard';
import ManpowerDashboard from './ManpowerDashboard';
import Sidebar from './Sidebar';
import ComingSoon from './ComingSoon';
import EmployeeTargetCrud from './EmployeeTarget';
import EmployeeTargets from './EmployeeTarget';
import PortAvailableCount from './PortAvailableCount';

function PrivateRoute() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;

}

const AppHeader: React.FC = () => {
  const { token } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="app-header d-flex align-items-center shadow bg-white position-fixed w-100" style={{ height: 64, top: 0, zIndex: 200, marginLeft: 10 }}>
      <div style={{ width: '80%' }}>
        <Link to="/" className="d-flex align-items-center text-decoration-none" style={{ paddingLeft: 16, marginLeft: 30 }}>
          {/* <img src={logo} alt="Logo" width={40} height={40} style={{ marginRight: 12 }} /> */}
          <span className="app-header-title">LDB Project Attendance System</span>
        </Link>
      </div>
      <div className="align-items-center" style={{ paddingRight: 24, width: '18%' }}>
        {token && (
          <div
            className="profile-avatar d-flex align-items-center justify-content-center ms-3"
            style={{ cursor: 'pointer', width: 40, height: 40, borderRadius: '50%', background: '#e0f7fa', boxShadow: '0 2px 8px #15608222' }}
            onClick={() => navigate(`/employees/edit/${token.id}`)}
            title="Update Profile"
          >
            {token.profile_image ? (
              <img src={token.profile_image} alt="Profile" style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }} />
            ) : (
              <i className="fas fa-user" style={{ fontSize: 22, color: '#156082' }} />
            )}
          </div>
        )}
      </div>

    </header>
  );
};

const Sidenavbar: React.FC = () => {
  const { isAuthenticated, logout, token } = useAuth();
  return (
    <Sidebar
      logo={nec_logo}
      token={token}
      isAuthenticated={isAuthenticated}
      logout={logout}
    />
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AppHeader />
      <Sidenavbar />
      <div style={{ marginLeft: 260, marginTop: 64, height: 'calc(100vh - 64px)', overflowY: 'auto', background: '#f8fafc' }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<PrivateRoute />}>
            <Route path="" element={<Home />} />
            <Route path="daily-attendance" element={<DailyAttendance />} />
            <Route path="location-tracking" element={<LocationTrackingReport />} />
            <Route path="ports" element={<PortsList />} />
            <Route path="ports/create" element={<PortCreate />} />
            <Route path="ports/edit/:id" element={<PortEdit />} />
            <Route path="designations" element={<DesignationList />} />
            <Route path="designations/create" element={<CreateDesignation />} />
            <Route path="designations/edit/:id" element={<EditDesignation />} />
            <Route path="terminals" element={<TerminalList />} />
            <Route path="terminals/create" element={<CreateTerminal />} />
            <Route path="terminals/edit/:id" element={<EditTerminal />} />
            <Route path="shifts" element={<ShiftList />} />
            <Route path="shifts/create" element={<CreateShift />} />
            <Route path="shifts/edit/:id" element={<EditShift />} />
            <Route path="employees" element={<EmployeeList />} />
            <Route path="employees/create" element={<CreateEmployee />} />
            <Route path="employees/edit/:id" element={<EditEmployee />} />
            <Route path="equipments" element={<EquipmentList />} />
            <Route path="equipments/activity/create" element={<CreateEquipmentActivity />} />
            <Route path="site-type" element={<SiteTypePage />} />
            <Route path="sites" element={<PMSitePage />} />
            <Route path="site-places" element={<PMSitePlacePage />} />
            <Route path="preventive-maintenance" element={<PreventiveMaintenanceReport />} />
            <Route path="maintenance-details" element={<PMReportDetails />} />
            <Route path="pmstatus" element={<PMStatus />} />
            <Route path="engineer-task-dashboard" element={<EngineerTaskDashboard />} />
            <Route path="manpower-dashboard" element={<ManpowerDashboard />} />
            <Route path="targets" element={<EmployeeTargets />} />
            <Route path="available-count" element={<PortAvailableCount />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
